<script>
  // packages
  import { intcomma } from 'journalize';

  // local
  import { formatPercent } from '../utils/format.js';
  import Photos from './Photos.svelte';

  /** @type {import('../types.d').ReadableRace} */
  export let race;

  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  function slugify(/** @type {string} */ text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }

</script>

{#each $race.candidates as candidate, idx}
  {#if idx < 2}
    <div class="candidate-results">
      <div class="img-container">
        <div class="candidate-headshot {slugify(candidate.given_name)} {candidate.party}">
            <Photos
              name={`${candidate.givenName} ${candidate.familyName}`}
              img={crosswalk.get(candidate.ap_id).img}
              avif={crosswalk.get(candidate.ap_id).avif}
              webp={crosswalk.get(candidate.ap_id).webp}
              party={candidate.party}
            />
        </div>
      </div>
      <div class= 'text-left'>
        <dl class="candidate-results-list">
          <dt class="visually-hidden">Voter choice</dt>
          <dd class="choice-label">
            {#if candidate.is_winner}
              <span class="checkmark">✓</span>
            {/if}
            {candidate.given_name}
            {candidate.family_name}
          </dd>
          <dt class="visually-hidden">Vote percentage</dt>
          <dd class="vote-percentage vote-percentage-{candidate.party}">
            {formatPercent(candidate.votes, $race.total_votes)}%
          </dd>
          <dt class="visually-hidden">Total votes</dt>
          <dd class="vote-count">{intcomma(candidate.votes)} votes</dd>
        </dl>
      </div>
    </div>
  {/if}
{/each}
